import { isRefComponent } from '../../services/StructureBuilder/structureUtil';
import {
  addAllComponentsToClosedWidget,
  addComponentToClosedWidget,
} from './addComponentToClosedWidgetUtils';
import {
  addAllComponentsToOpenWidget,
  addComponentToOpenWidget,
} from './addComponentToOpenWidgetUtils';

export const addComponent = async (
  editorSDK: any,
  masterStructureFetcher: any,
  widgetRef: any,
  componentRole: any,
) => {
  const isRef = await isRefComponent(editorSDK, widgetRef);
  if (isRef) {
    return addComponentToClosedWidget(editorSDK, widgetRef, componentRole);
  }
  const masterStructure = await masterStructureFetcher.fetchMasterStructure(
    widgetRef,
  );
  return addComponentToOpenWidget(
    editorSDK,
    widgetRef,
    componentRole,
    masterStructure,
  );
};

export const addAllComponents = async (
  editorSDK: any,
  masterStructureFetcher: any,
  widgetRef: any,
) => {
  const isRef = await isRefComponent(editorSDK, widgetRef);
  if (isRef) {
    return addAllComponentsToClosedWidget(editorSDK, widgetRef);
  }
  const masterStructure = await masterStructureFetcher.fetchMasterStructure(
    widgetRef,
  );
  return addAllComponentsToOpenWidget(editorSDK, widgetRef, masterStructure);
};
